module.exports = __webpack_public_path__ + "img/hygl.68818e85.png";